/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type JoblistingType = "OT" | "PP" | "SI" | "%future added value";
export type JoblistingView_joblisting = {
    readonly id: string;
    readonly company: {
        readonly name: string;
        readonly logo: string | null;
        readonly description: string;
        readonly url: string | null;
        readonly id: string;
    };
    readonly towns: ReadonlyArray<{
        readonly name: string;
    }>;
    readonly image: string | null;
    readonly deadline: string | null;
    readonly title: string;
    readonly type: JoblistingType;
    readonly description: string | null;
    readonly fromGrade: number;
    readonly toGrade: number;
    readonly url: string;
    readonly dateCreated: string;
    readonly videoUrl: string | null;
    readonly isActive: boolean;
    readonly " $refType": "JoblistingView_joblisting";
};
export type JoblistingView_joblisting$data = JoblistingView_joblisting;
export type JoblistingView_joblisting$key = {
    readonly " $data"?: JoblistingView_joblisting$data;
    readonly " $fragmentRefs": FragmentRefs<"JoblistingView_joblisting">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JoblistingView_joblisting",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "height",
              "value": 260
            },
            {
              "kind": "Literal",
              "name": "width",
              "value": 1127
            }
          ],
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": "logo(height:260,width:1127)"
        },
        (v2/*: any*/),
        (v3/*: any*/),
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Town",
      "kind": "LinkedField",
      "name": "towns",
      "plural": true,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fromGrade",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toGrade",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateCreated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    }
  ],
  "type": "Joblisting",
  "abstractKey": null
};
})();
(node as any).hash = '38d9188a8b649bb410eb6683e8aacd37';
export default node;
